import React from 'react';
import PropTypes from 'prop-types';

import {
  StyledGenericSectionHeader,
  GenericHeaderTitle,
} from 'Webapp/shared/app/components/generic-section-header';

const SitemapHeader = ({ children }) => (
  <StyledGenericSectionHeader>
    <GenericHeaderTitle>{children}</GenericHeaderTitle>
  </StyledGenericSectionHeader>
);

SitemapHeader.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SitemapHeader;
